import React from 'react'
import { TimeLine,Intro,Skills } from '../Components'
import { Container} from "react-bootstrap";
const Timeline = () => {
    return (
        <div className="Home_body__2gksT " id="myTimeline">
        
        <div className="Home_mainBody__2p4-X ">
          <h1 className="mb-4 text-center font-weight-light">
            My <strong className="purple">Timeline</strong>
          </h1>
          <hr style={{ margin: "0px 10%" }} />
          <div className="row">
            <div className="col-md-12">
            <TimeLine
                position="Software Engineer"
                companyName="Aakash Educational Services Limited" 
                duration="July 2022 - Present"
                workInformation={
                  <>
                   <div style={{textAlign:'left'}}>
                    <p style={{ marginBottom: "5px" }}>
                    Design and Managed Local Docker Setup (Containerization). 
                    </p>
                    <p style={{ marginBottom: "5px" }}>
                    Developed Rest Api's in Laravel that helped the company to meet its goals and ensure major success.
                    </p>
                    <p style={{ marginBottom: "5px" }}>Using statistical Tool to identify, analyze, and interpret patterns and trends in complex data set that could be
                        helpful for the diagnosis.</p>
                    <p>Performing analysis to assess quality and meaning of Data.</p>
                    </div>
                  </>
                }
              />
            <TimeLine
                position="Application Engineer Intern"
                companyName="Aakash Educational Services Limited" 
                duration="January 2022 - July 2022"
                workInformation={
                  <>
                   <div style={{textAlign:'left'}}>
                    <p style={{ marginBottom: "5px" }}>
                    Proficiency in Drupal with custom module development
                    </p>
                    <p style={{ marginBottom: "5px" }}>
                    Software design, development and investigation into new technologies
                    </p>
                    <p>Provide custom development and functionality for Drupal multisite web application</p>
                    </div>
                  </>
                }
              />
            <TimeLine
                position="Full Stack Developer"
                companyName="Access-School IT Pvt. Ltd."
                duration="December 2021- January 2022"
                workInformation={
                  <>
                   <div style={{textAlign:'left'}}>
                    <p style={{ marginBottom: "5px" }}>
                   Manage and develop the website and its backend.
                    </p>
                    <p style={{ marginBottom: "5px" }}>
                    Design and communicate project requirements
                    </p>
                    <p> Developed community for the alumni</p>
                    </div>
                  </>
                }
              />
              <TimeLine
                position="Full-Stack Developer Intern"
                companyName="OpenCubicles Technologies Pvt Ltd."
                duration="April 2021- August 2021"
                workInformation={
                  <>
                  <div style={{textAlign:'left'}}>
                    <p style={{ marginBottom: "5px" }}>
                      Manage Website Development Projects from initial Design
                      though completion, Optimizing all-cross browsers and
                      multi-platform compatibility.
                    </p>
                    <p style={{ marginBottom: "5px" }}>
                      Work Closely with Programmers to meet project requirement,
                      goals and desired functionality.
                    </p>
                    <p> Major contribution in Laravel projects.</p>
                    </div>
                  </>
                }
              />
              <TimeLine
                position="JavaScript Developer Intern"
                companyName="HenryHarvin Education"
                duration="December 2020 - Februray 2021"
                workInformation={
                  <>
                   <div style={{textAlign:'left'}}>
                    <p style={{ marginBottom: "5px" }}>
                      Developed web Pages from front to backend using PHP &
                      JAVASCRIPT
                    </p>
                    <p style={{ marginBottom: "5px" }}>
                      Implemented Enhancements that improved Web functionality
                      and responsiveness and Major Developments are Buy course
                      notification and refer and earn section.
                    </p>
                    </div>
                  </>
                }
              />
              <TimeLine
                position="Under Graduation"
                companyName="Dronacharya College Of Engineering"
                duration="August 2018 - Current"
                workInformation={
                  <>
                    <p style={{ marginBottom: "5px" }}>
                      Computer Science and Engineering
                    </p>
                    <p style={{ color: "gray" }}>80%</p>
                  </>
                }
              />
              <TimeLine
                position="Senior Secondary"
                companyName="Bala Pritam Guru Harkishan International Public School"
                duration="2016 - 2018"
                workInformation={
                  <>
                    <p style={{ marginBottom: "5px" }}>CBSE</p>
                    <p style={{ color: "gray" }}>70%</p>
                  </>
                }
              />
              <TimeLine
                position="High School"
                companyName="Bala Pritam Guru Harkishan International Public School"
                duration="2014 - 2016"
                workInformation={
                  <>
                    <p style={{ marginBottom: "5px" }}>CBSE</p>
                    <p style={{ color: "gray" }}>82%</p>
                  </>
                }
              />
            </div>
          </div>
        </div>
        <Container>
          <Intro />
          <br />
          <br />
          <Skills />
        </Container>
      </div>
    )
}

export default Timeline
